export class ConversationPropertyModel {
	conversationId: number;
	propertyName: string = '';
	propertyValue: string;
}
